<script setup lang="ts">
    import { COLOR_PALETTE } from '@/utils/colorPalette';

    const model = defineModel<string>({ default: '#000000' });

    function switchColor(color: string) {
        model.value = color;
    }
</script>

<template>
    <div class="h-78 w-72 rounded-md bg-white p-6 shadow">
        <div class="flex flex-col gap-2">
            <div
                v-for="(row, rowIndex) in COLOR_PALETTE"
                :key="'row-' + rowIndex"
                class="flex gap-2"
            >
                <button
                    v-for="(color, colIndex) in row"
                    :key="'cell-' + rowIndex + '-' + colIndex"
                    class="h-7 w-7 rounded-full shadow-md transition-transform duration-150 ease-in-out hover:scale-125 focus:outline-none"
                    :style="{ backgroundColor: color }"
                    @click="switchColor(color)"
                >
                    <span class="sr-only"> {{ $t('select_color') }} {{ color }} </span>
                </button>
            </div>
        </div>
    </div>
</template>
